import React from 'react';

import { Image, UIHeading2, UIText1 } from '@cian/ui-kit';

import styles from './styles.css';

export interface IHeaderProps {
  title: string;
  description: string;
  logoUrl: string;
}

export const Header: React.FC<IHeaderProps> = ({ title, description, logoUrl }) => {
  return (
    <div className={styles['root']}>
      <div className={styles['text-content']}>
        <UIHeading2>{title}</UIHeading2>
        <UIText1>{description}</UIText1>
      </div>
      <div className={styles['icon']}>
        <Image src={logoUrl} alt={logoUrl} borderRadius={'50%'} preloader />
      </div>
    </div>
  );
};

Header.displayName = 'Header';
